import styled from 'styled-components';
import { COLORS } from '@/theme';
import { StyledConversationId } from '@/modules/SuggestedFaq';

export const StyledMetaRow = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  padding-top: 1.25rem;
  border-top: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
`;

export const StyledMetaColumn = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    display: flex;
    flex-wrap: wrap;
    gap: 0.375rem;
  }
`;

export const StyledSourceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledConversationLink = styled(StyledConversationId)`
  text-decoration: underline !important;
`;
